import { HTMLAttributes } from 'react';

export interface IIconProps extends HTMLAttributes<SVGElement> {
  width?: number | string;
  height?: number | string;
  color?: string;
}

export enum IconSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}
